import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

const TABS = [
  { to: '/chit', label: 'Accounts', end: true },
  { to: '/chit/schemes', label: 'Schemes', end: true },
];

/** Switches between customer chit accounts and the scheme plans they enrol in. */
export function ChitTabs() {
  return (
    <div className="inline-flex gap-1 self-start rounded-card border border-border bg-surface-2 p-1">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            clsx(
              'rounded-card px-3.5 py-1.5 text-sm font-medium transition-colors',
              isActive ? 'bg-surface text-content' : 'text-muted hover:text-content',
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}

export default ChitTabs;
